module.exports = __webpack_public_path__ + "img/zhouheiya.5db88f71.png";